<template>
    <div class="loading">
        <div v-if="loadStyle == 0" class="loadingOne">
            <img src="../../static/images/loading_square.gif" alt="loading">
            <div v-html= "content" class="load_content">{{content}}</div>
            <Button v-if="isBtn" @click="cancelSpin" class="cancel_btn" :disabled="disabled">取消</Button>
        </div>
        <div v-else class="loadingTwo">
            <img src="../../static/images/loading.gif" alt="loading">
            <div v-html= "content">{{content}}</div>
        </div>
    </div>
</template>
<script>
    export default {
        props:['content','isBtn','disabled','router','loadStyle'],
        name: "spin",
        mounted(){
            if(this.loadStyle == 0){
            // .ivu-spin-fix{z-index: 200 !important;}
              document.getElementsByClassName('ivu-spin-fix')[0].setAttribute("style","background-color: rgba(0,0,0,0.8) !important");
            }else {
              document.getElementsByClassName('ivu-spin-fix')[0].setAttribute("style","background-color: rgba(0,0,0,0) !important;z-index:2000 !important");
              document.getElementsByClassName('ivu-spin-fullscreen-wrapper')[0].setAttribute("style","z-index:2000 !important");
            }
        },
        methods:{
            cancelSpin(){
                this.$emit('cancel_btn');
                this.$Spin.hide();
            }
        },
    }
</script>

<style scoped>
.loading{display: flex;align-items: center;justify-content: center;}
.load_content{color: #fff;font-size:32px}
.cancel_btn{font-size: 18px;margin-top: 42.5px;width: 220px;height:49px;line-height: 39px;font-size: 18px;color: #fff;background-color: #d50707 !important;border-color:#d50707 !important; }
.cancel_btn:hover{background-color: #fd5151 !important;border-color:#fd5151 !important;color: #fff; }
.cancel_btn:active{background-color: #9e0505 !important;border-color:#9e0505 !important;color: #fff;}
.loadingOne img{margin-bottom: 20px}
.loadingTwo{      width: 260px;
    height: 180px;
    /*background: rgba(24,24,24,0.3);*/
    /*background: rgba(81,90,110,0.2);*/
    text-align: center;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;}
.loadingTwo div{
    color: #fff;
    margin-top: 10px;font-size: 14px}
</style>
